import { ScanPipelineStatuses } from '../../../../../services/entities/impl/blfApi/schemas/scan';

/**
 * Maps a scan pipeline status to a corresponding MUI color
 *
 * @param status - The pipeline status to map to a color
 * @returns A Material-UI color string ('success', 'error', 'primary', or 'default')
 *
 * Success: Completed
 * Error: Error, Completed With Errors, or any unknown status
 * Primary: In Progress, Uploading
 * Default: Pending
 */
export const getPipelineStatusColor = (
  status: string
): 'success' | 'error' | 'primary' | 'default' => {
  // Check if status is a valid ScanPipelineStatuses
  const isValidStatus = (status: string): status is ScanPipelineStatuses => {
    return (
      (status as ScanPipelineStatuses) !== undefined &&
      [
        'Pending',
        'In Progress',
        'Completed',
        'Completed With Errors',
        'Error',
        'Uploading',
      ].includes(status)
    );
  };

  // If status is not valid, return 'error'
  if (!isValidStatus(status)) {
    console.warn(`Invalid pipeline status: ${status}`);
    return 'error';
  }

  // Map valid statuses to colors
  switch (status) {
    case 'Completed':
      return 'success';
    case 'Error':
    case 'Completed With Errors':
      return 'error';
    case 'In Progress':
    case 'Uploading':
      return 'primary';
    case 'Pending':
      return 'default';
  }
};
